import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OperationsRoutes } from './operations.routing';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { SharedMaterialModule } from 'src/app/shared/shared-material.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxFileDropModule } from 'ngx-file-drop';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MdePopoverModule } from "@muntazir86/material-extended";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { AllDocumentsComponent } from './all-documents/all-documents.component';
import { BuyerRfqListComponent } from './buyer-rfq-list/buyer-rfq-list.component';

import { ChatModule } from 'src/app/views/chat/chat.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SupplierRfqListComponent } from './supplier-rfq-list/supplier-rfq-list.component';
import { SupplierServiceRfqListComponent } from './supplier-service-rfq-list/supplier-service-rfq-list.component';
import { SupplierQuoteListComponent } from './supplier-quote-list/supplier-quote-list.component';
import { BuyerQuoteListComponent } from './buyer-quote-list/buyer-quote-list.component';
import { PurchaseOrderLineItemsComponent } from './purchase-order/purchase-order-line-items/purchase-order-line-items.component';
import { PurchaseOrderHeaderComponent} from './purchase-order/purchase-order-header/purchase-order-header.component';
import { PurchaseOrderPaymentTermsComponent } from './purchase-order/purchase-order-payment-terms/purchase-order-payment-terms.component';
import { PurchaseOrderPreviewComponent } from "./purchase-order/purchase-order-preview/purchase-order-preview.component"
import { PurchaseOrderListComponent } from './purchase-order/purchase-order-list/purchase-order-list.component';
import { SupplierPurchaseOrderListComponent } from './purchase-order/supplier-purchase-order-list/supplier-purchase-order-list.component';
import { PurchaseOrderDetailsComponent } from './purchase-order/purchase-order-details/purchase-order-details.component';
import { TokenLoginComponent } from './purchase-order/po-token-login/po-token-login.component';
import { PoTokenPurchaseOrderDetailsComponent } from './purchase-order/po-token-login/po-details/po-details.component';
import { PurchaseOrderApprovalListComponent } from './purchase-order/purchase-order-approval-list/purchase-order-approval-list.component';
import { PurchaseOrderApprovalDetailsComponent } from './purchase-order/purchase-order-approval-details/purchase-order-approval-details.component';
import { CreateInvoiceComponent } from './create-invoice/create-invoice.component';
import { InvoiceListComponent } from './invoice-list/invoice-list.component';
import { SupplierInvoicesListComponent } from './invoice-list/supplier-invoices-list/supplier-invoices-list.component';
import { BuyerInvoicesListComponent } from './invoice-list/buyer-invoices-list/buyer-invoices-list.component';
import { CreateDispatchComponent } from './create-dispatch/create-dispatch.component';
import { ConfirmOrderReceiptComponent } from './confirm-order-receipt/confirm-order-receipt.component';
import { OrderReceiptDetailsComponent } from './order-receipt-details/order-receipt-details.component';
import { ContactDetailsComponent } from './contact-details/contact-details.component';
import { DocumentPreviewComponent } from './document-preview/document-preview.component';
import { PurchaseOrderApprovalDetailsPreviewComponent } from './purchase-order/purchase-order-approval-details-preview/purchase-order-approval-details-preview'
import { SupportTicketSystemComponent } from './support-ticket-system/support-ticket-system';
import { BuyerSupportTicketSystemComponent } from './support-ticket-system/buyer-support-ticket-system/buyer-support-ticket-system.component';
import { SupplierSupportTicketSystemComponent } from './support-ticket-system/supplier-support-ticket-system/supplier-support-ticket-system.component';
import { AdminSupportTicketSystemComponent } from './support-ticket-system/admin-support-ticket-system/admin-support-ticket-system.component';
import { ServiceSupplierQuoteListComponent } from './service-supplier-quote-list/service-supplier-quote-list.component';
import { BuyerServiceRfqListComponent } from './buyer-service-rfq-list/buyer-service-rfq-list.component';
import { BuyerServiceQuoteListComponent } from './buyer-service-quote-list/buyer-service-quote-list.component';
import { ServicePurchaseOrderLineItemsComponent } from './service-purchase-order/service-purchase-order-line-items/service-purchase-order-line-items.component';
import { ServicePurchaseOrderHeaderComponent } from './service-purchase-order/service-purchase-order-header/service-purchase-order-header.component';
import { ServicePurchaseOrderPaymentTermsComponent } from './service-purchase-order/service-purchase-order-payment-terms/service-purchase-order-payment-terms.component';
import { ServicePurchaseOrderPreviewComponent } from './service-purchase-order/service-purchase-order-preview/service-purchase-order-preview.component';
import { BuyerServicePurchaseOrderListComponent } from './buyer-service-purchase-order-list/buyer-service-purchase-order-list.component';
import { SupplierServicePurchaseOrderListComponent } from './supplier-service-purchase-order-list/supplier-service-purchase-order-list.component';

@NgModule({
  declarations: [
    AllDocumentsComponent,
    BuyerRfqListComponent,
    SupplierRfqListComponent,
    SupplierServiceRfqListComponent,
    SupplierQuoteListComponent,
    BuyerQuoteListComponent,
    PurchaseOrderLineItemsComponent,
    PurchaseOrderHeaderComponent,
    PurchaseOrderPaymentTermsComponent,
    PurchaseOrderPreviewComponent,
    PurchaseOrderListComponent,
    SupplierPurchaseOrderListComponent,
    PurchaseOrderDetailsComponent,
    PurchaseOrderApprovalListComponent,
    PurchaseOrderApprovalDetailsComponent,
    PurchaseOrderApprovalDetailsPreviewComponent,
    TokenLoginComponent,
    PoTokenPurchaseOrderDetailsComponent,
    CreateInvoiceComponent,
    InvoiceListComponent,
    SupplierInvoicesListComponent,
    BuyerInvoicesListComponent,
    CreateDispatchComponent,
    ConfirmOrderReceiptComponent,
    OrderReceiptDetailsComponent,
    ContactDetailsComponent,
    DocumentPreviewComponent,
    SupportTicketSystemComponent,
    BuyerSupportTicketSystemComponent,
    SupplierSupportTicketSystemComponent,
    AdminSupportTicketSystemComponent,
    ServiceSupplierQuoteListComponent,
    BuyerServiceRfqListComponent,
    BuyerServiceQuoteListComponent,
    ServicePurchaseOrderLineItemsComponent,
    ServicePurchaseOrderHeaderComponent,
    ServicePurchaseOrderPaymentTermsComponent,
    ServicePurchaseOrderPreviewComponent,
    BuyerServicePurchaseOrderListComponent,
    SupplierServicePurchaseOrderListComponent
  ],
  imports: [
    CommonModule,
    
        SharedModule,
        ReactiveFormsModule,
        SharedMaterialModule,
        TranslateModule,
        FormsModule ,
        NgxFileDropModule,
        PdfViewerModule,
        MdePopoverModule,
        NgxDatatableModule,
        MatButtonModule,
        MatMenuModule,
        MatIconModule,
        MatCheckboxModule,
        MatTooltipModule,
        ChatModule,
        RouterModule.forChild(OperationsRoutes),
  ]
})
export class OperationsModule { }
